import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { API_BASE } from "../../utils/api";
import "./Tables.css";

const makeStyle = (status) => {
  if (status === "Approved") {
    return { color: "green", fontWeight: "bold" };
  } else if (status === "rejected") {
    return { color: "red", fontWeight: "bold" };
  } else {
    return { color: "blue", fontWeight: "bold" };
  }
};

export default function PrimeProductTable({ searchQuery }) {
  const [stageProducts, setStageProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const navigate = useNavigate();

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return isNaN(date.getTime())
      ? "N/A"
      : date.toLocaleDateString(undefined, {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
  };

  const routeChange = (productId) => {
    // navigate(`/product/productdetail/${productId}`);
    window.location.href = `/product/productdetail/${productId}`;
  };

  useEffect(() => {
    const fetchStageProducts = async () => {
      try {
        const response = await axios.get(`${API_BASE}/api/products/combined`);
        setStageProducts(response.data);
      } catch (error) {
        console.error("Error fetching products:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchStageProducts();
  }, []);

 const imageBodyTemplate = (rowData) => {
  const imageUrl = rowData.images?.[0];
  return imageUrl ? (
    <img
      src={`${API_BASE}${imageUrl}`}
      alt={rowData.productName}
      className="table-image"
    />
  ) : (
    <span>No Image</span>
  );
};

  const statusBodyTemplate = (rowData) => (
    <span style={makeStyle(rowData.status)}>{rowData.status}</span>
  );

  const expiryBodyTemplate = (rowData) => {
    const firstVariant = rowData.variants?.[0];
    return firstVariant?.expiryDate
      ? formatDate(firstVariant.expiryDate)
      : "N/A";
  };

  const manufactureBodyTemplate = (rowData) => {
    const firstVariant = rowData.variants?.[0];
    return firstVariant?.manufactureDate
      ? formatDate(firstVariant.manufactureDate)
      : "N/A";
  };

  const filteredProducts = stageProducts.filter((product) => {
    const searchableFields = [
      product.productName,
      product.productNumber,
      product.productDetails,
      product.categoryName,
      product.subcategoryName,
      formatDate(product.variants?.[0]?.manufactureDate),
      formatDate(product.variants?.[0]?.expiryDate),
      product.status,
    ];
    return searchableFields.some(
      (field) =>
        field &&
        field.toString().toLowerCase().includes(searchQuery.toLowerCase())
    );
  });


 const responsiveColumnHeader = (header) => (rowData, { field }) =>
  <div className="responsive-cell">
    <span className="responsive-header">{header}</span>
    <span className="responsive-value">
      {field === 'image'
        ? imageBodyTemplate(rowData)
        : field === 'manufactureDate'
          ? manufactureBodyTemplate(rowData)
          : field === 'expiryDate'
            ? expiryBodyTemplate(rowData)
            : field === 'status'
              ? statusBodyTemplate(rowData)
              : rowData[field]}
    </span>
  </div>;


  return (
    <div className="datatable-wrapper">
      <DataTable
        value={filteredProducts}
        paginator
        rows={rows}
        first={first}
        onPage={(e) => {
          setFirst(e.first);
          setRows(e.rows);
        }}
        loading={loading}
        responsiveLayout="stack"
        scrollable
        scrollHeight="450px"
        selectionMode="single"
        onRowClick={(e) => routeChange(e.data._id)}
        emptyMessage="No results found"
        stripedRows
        className="datatable-scrollable"
      >
        <Column
          field="image"
          header="Image"
          body={responsiveColumnHeader("Image")}
          style={{ width: "100px" }}
        />
        <Column field="productName" header="Product Name" body={responsiveColumnHeader("Product Name")} sortable />
        <Column field="productNumber" header="Product Number" body={responsiveColumnHeader("Product Number")} sortable />
        <Column field="categoryName" header="Category" body={responsiveColumnHeader("Category")} sortable />
        <Column field="subcategoryName" header="Subcategory" body={responsiveColumnHeader("Subcategory")} sortable />
        <Column field="productDetails" header="Product Details" body={responsiveColumnHeader("Product Details")} />
        <Column field="manufactureDate" header="Manufacture Date" body={responsiveColumnHeader("Manufacture Date")} sortable />
        <Column field="expiryDate" header="Expiry Date" body={responsiveColumnHeader("Expiry Date")} sortable />
        <Column field="status" header="Status" body={responsiveColumnHeader("Status")} sortable />
      </DataTable>
    </div>
  );
}
